var _regeneratorRuntime = require("/var/jenkins_home/workspace/oc-chat/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/var/jenkins_home/workspace/oc-chat/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/var/jenkins_home/workspace/oc-chat/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/jenkins_home/workspace/oc-chat/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/jenkins_home/workspace/oc-chat/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/jenkins_home/workspace/oc-chat/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/jenkins_home/workspace/oc-chat/node_modules/@babel/runtime/helpers/inherits");

var EventEmitter = require('events');

var SIP =
/*#__PURE__*/
function (_EventEmitter) {
  "use strict";

  _inherits(SIP, _EventEmitter);

  function SIP(janus) {
    var _this;

    _classCallCheck(this, SIP);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SIP).call(this));
    _this.janus = janus;
    _this.pluginHandle = null;
    _this.isHold = false;
    _this.stream = null;
    return _this;
  }

  _createClass(SIP, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this2.janus) return reject('no janus');
                  var plugin = {
                    plugin: 'janus.plugin.sip',
                    //plugin: 'janus.plugin.sipre',
                    success: function success(pluginHandle) {
                      _this2.pluginHandle = pluginHandle;
                      resolve();
                    },
                    error: function error(_error) {
                      reject(_error);
                    },
                    onmessage: function onmessage(msg, jsep) {
                      if (msg.result) {
                        switch (msg.result.event) {
                          case 'registration_failed':
                            _this2.emit('registration-failed', msg);

                            break;

                          case 'registered':
                            _this2.emit('registered', msg);

                            break;

                          case 'calling':
                            _this2.emit('calling', msg);

                            break;

                          case 'incomingcall':
                            _this2.emit('incoming-call', {
                              msg: msg,
                              jsep: jsep
                            });

                            break;

                          case 'progress':
                            if (jsep !== null && jsep !== undefined) {
                              _this2.pluginHandle.handleRemoteJsep({
                                jsep: jsep,
                                error: function error(_error2) {
                                  console.log(_error2);
                                }
                              });
                            }

                            _this2.emit('progress', msg);

                            break;

                          case 'accepting':
                            _this2.emit('accepting', msg);

                            break;

                          case 'accepted':
                            if (jsep !== null && jsep !== undefined) {
                              _this2.pluginHandle.handleRemoteJsep({
                                jsep: jsep,
                                error: function error(_error3) {
                                  console.log(_error3);
                                }
                              });
                            }

                            _this2.emit('accepted', msg);

                            break;

                          case 'hangup':
                            _this2.emit('hangup', msg);

                            break;

                          case 'holding':
                            _this2.isHold = true;
                            break;

                          case 'resuming':
                            _this2.isHold = false;
                            break;

                          case 'recordingupdated':
                            _this2.emit('recording');

                            break;

                          default:
                            //console.log(msg)
                            break;
                        }
                      }
                    },
                    onlocalstream: function onlocalstream(stream) {
                      _this2.stream = stream;

                      _this2.emit('localstream', stream);
                    },
                    onremotestream: function onremotestream(stream) {
                      _this2.emit('remotestream', stream);
                    }
                  };

                  _this2.janus.attach(plugin);
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "register",
    value: function () {
      var _register = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(_ref) {
        var _this3 = this;

        var username, password, server, user_agent;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                username = _ref.username, password = _ref.password, server = _ref.server, user_agent = _ref.user_agent;
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this3.pluginHandle) return reject('plugin not initialized');
                  var message = {
                    request: 'register',
                    username: username,
                    secret: password,
                    proxy: server,
                    outbound_proxy: server,
                    user_agent: user_agent
                  };

                  _this3.pluginHandle.send({
                    message: message
                  });

                  return resolve();
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function register(_x) {
        return _register.apply(this, arguments);
      }

      return register;
    }()
  }, {
    key: "unregister",
    value: function unregister() {
      this.pluginHandle && this.pluginHandle.send({
        message: {
          request: 'unregister'
        }
      });
    }
  }, {
    key: "call",
    value: function () {
      var _call = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(number) {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this4.pluginHandle) return reject('plugin not initialized');

                  _this4.pluginHandle.createOffer({
                    media: {
                      audioSend: true,
                      audioRecv: true,
                      videoSend: false,
                      videoRecv: false
                    },
                    success: function success(jsep) {
                      _this4.pluginHandle.send({
                        message: {
                          request: 'call',
                          uri: number
                        },
                        jsep: jsep
                      });

                      resolve();
                    },
                    error: function error(_error4) {
                      reject(_error4);
                    }
                  });
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function call(_x2) {
        return _call.apply(this, arguments);
      }

      return call;
    }()
  }, {
    key: "mute",
    value: function () {
      var _mute = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(isMuted) {
        var _this5 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this5.pluginHandle) return reject('plugin not initialized');
                  if (!_this5.stream) return reject('stream does not exists');
                  _this5.stream.getAudioTracks()[0].enabled = !isMuted;
                  return resolve();
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function mute(_x3) {
        return _mute.apply(this, arguments);
      }

      return mute;
    }()
  }, {
    key: "answer",
    value: function () {
      var _answer = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(jsep) {
        var _this6 = this;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this6.pluginHandle) return reject('plugin not initialized');
                  var action;

                  if (jsep) {
                    action = _this6.pluginHandle.createAnswer;
                  } else {
                    action = _this6.pluginHandle.createOffer;
                  }

                  action({
                    jsep: jsep,
                    media: {
                      audio: true,
                      video: false
                    },
                    success: function success(jsep) {
                      _this6.pluginHandle.send({
                        message: {
                          request: 'accept'
                        },
                        jsep: jsep
                      });

                      resolve();
                    },
                    error: function error(_error5) {
                      _this6.pluginHandle.send({
                        message: {
                          request: 'decline',
                          code: 480
                        }
                      });

                      reject(_error5);
                    }
                  });
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function answer(_x4) {
        return _answer.apply(this, arguments);
      }

      return answer;
    }()
  }, {
    key: "hang",
    value: function () {
      var _hang = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var _this7 = this;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this7.pluginHandle) return reject('plugin not initialized');

                  _this7.pluginHandle.send({
                    message: {
                      request: 'hangup'
                    }
                  });

                  _this7.pluginHandle.hangup();

                  return resolve();
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function hang() {
        return _hang.apply(this, arguments);
      }

      return hang;
    }()
  }, {
    key: "decline",
    value: function () {
      var _decline = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var _this8 = this;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this8.pluginHandle) return reject('plugin not initialized');

                  _this8.pluginHandle.send({
                    message: {
                      request: 'decline'
                    }
                  });

                  return resolve();
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function decline() {
        return _decline.apply(this, arguments);
      }

      return decline;
    }()
  }, {
    key: "sendDTMF",
    value: function () {
      var _sendDTMF = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(tones) {
        var _this9 = this;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this9.pluginHandle) return reject('plugin not initialized');

                  if (!tones.match(/^([0-9]|[#\*])+$/g)) {
                    return reject('wrong value');
                  }

                  _this9.pluginHandle.dtmf({
                    dtmf: {
                      tones: tones
                    }
                  });

                  return resolve();
                }));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function sendDTMF(_x5) {
        return _sendDTMF.apply(this, arguments);
      }

      return sendDTMF;
    }()
  }, {
    key: "hold",
    value: function () {
      var _hold = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var _this10 = this;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this10.pluginHandle) return reject('plugin not initialized');

                  _this10.pluginHandle.send({
                    message: {
                      request: "hold"
                    }
                  });

                  return resolve();
                }));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function hold() {
        return _hold.apply(this, arguments);
      }

      return hold;
    }()
  }, {
    key: "unhold",
    value: function () {
      var _unhold = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var _this11 = this;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this11.pluginHandle) return reject('plugin not initialized');

                  _this11.pluginHandle.send({
                    message: {
                      request: "unhold"
                    }
                  });

                  return resolve();
                }));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function unhold() {
        return _unhold.apply(this, arguments);
      }

      return unhold;
    }()
  }, {
    key: "startRecording",
    value: function () {
      var _startRecording = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(filename) {
        var _this12 = this;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this12.pluginHandle) return reject('plugin not initialized');

                  _this12.pluginHandle.send({
                    message: {
                      request: 'recording',
                      action: 'start',
                      audio: true,
                      video: false,
                      peer_audio: true,
                      peer_video: false,
                      filename: filename
                    }
                  });

                  return resolve();
                }));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function startRecording(_x6) {
        return _startRecording.apply(this, arguments);
      }

      return startRecording;
    }()
  }, {
    key: "stopRecording",
    value: function () {
      var _stopRecording = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        var _this13 = this;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this13.pluginHandle) return reject('plugin not initialized');

                  _this13.pluginHandle.send({
                    message: {
                      request: 'recording',
                      action: 'stop',
                      audio: true,
                      video: false,
                      peer_audio: true,
                      peer_video: false
                    }
                  });

                  return resolve();
                }));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function stopRecording() {
        return _stopRecording.apply(this, arguments);
      }

      return stopRecording;
    }()
  }]);

  return SIP;
}(EventEmitter);

module.exports = SIP;